import React from 'react';

import Table from 'components/shared/table';
import ArchivesTableBody from './body';
import ArchiveTableHeader from './header';
import ArchiveTableFooter from './footer';

const ArchivesTable = ({
  archivables = [],
  type,
  pageCount,
  page,
  setPage,
  query,
  setQuery,
  totalResults,
  loading,
  error,
  selectedArchivables,
  setSelectedArchivables,
  handleBulkRestore,
  bulkActionStatus,
  canUnarchive,
}) => {
  const indeterminate = archivables.length !== selectedArchivables.length;

  const toggleArchivables = () => {
    if (indeterminate) {
      setSelectedArchivables(
        archivables.reduce((acc, _item, index) => [...acc, index], []),
      );
    } else {
      setSelectedArchivables([]);
    }
  };

  const toggleArchivable = index => {
    const indexArchivable = selectedArchivables.indexOf(index);

    if (indexArchivable > -1) {
      return setSelectedArchivables(
        selectedArchivables
          .slice(0, indexArchivable)
          .concat(selectedArchivables.slice(indexArchivable + 1)),
      );
    }

    return setSelectedArchivables(selectedArchivables.concat(index));
  };
  return (
    <Table
      className="Index-table--multipleHeaders"
      alternate
      noBorderTop
      roundedBottom
    >
      <ArchiveTableHeader
        archivables={archivables}
        loading={loading}
        error={error}
        type={type}
        query={query}
        setQuery={setQuery}
        totalResults={totalResults}
        toggleArchivables={toggleArchivables}
        indeterminate={indeterminate}
        selectedArchivables={selectedArchivables}
        handleBulkRestore={handleBulkRestore}
        bulkActionStatus={bulkActionStatus}
        canUnarchive={canUnarchive}
      />
      <ArchivesTableBody
        archivables={archivables}
        canUnarchive={canUnarchive}
        type={type}
        query={query}
        setQuery={setQuery}
        totalResults={totalResults}
        loading={loading}
        error={error}
        selectedArchivables={selectedArchivables}
        toggleArchivable={toggleArchivable}
        bulkActionStatus={bulkActionStatus}
      />
      <ArchiveTableFooter
        archivables={archivables}
        page={page}
        setPage={setPage}
        loading={loading}
        pageCount={pageCount}
      />
    </Table>
  );
};

export default ArchivesTable;
